import { useTranslation } from 'react-i18next'
import { toast } from '@/components/ui/toast'
import { ConfirmDeleteDialog } from '@/components/shared'
import { getApiErrorMessage } from '@/services/api'
import { useDeleteUser } from '@/hooks/useUsers'
import type { PortalUser } from '@/types'

interface DeleteUserDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  user: PortalUser | null
}

// 2.11.4 - Delete user (Admin only). Soft delete + GDPR anonymise server-side.
// Figma 1336:31123.
export function DeleteUserDialog({
  open,
  onOpenChange,
  user,
}: DeleteUserDialogProps) {
  const { t } = useTranslation('settings')
  const del = useDeleteUser()

  function handleConfirm() {
    if (!user) return
    del.mutate(user.id, {
      onSuccess: () => {
        toast({ variant: 'success', title: t('users.toast.deleted') })
        onOpenChange(false)
      },
      onError: e =>
        toast({ variant: 'destructive', title: getApiErrorMessage(e) }),
    })
  }

  return (
    <ConfirmDeleteDialog
      open={open}
      onOpenChange={o => !del.isPending && onOpenChange(o)}
      title={t('users.delete.title')}
      description={t('users.delete.message')}
      confirmLabel={t('users.delete.confirm')}
      onConfirm={handleConfirm}
      busy={del.isPending}
    />
  )
}

export default DeleteUserDialog
